// @flow
import React, { Component } from 'react'
import Dropdown, {
  DropdownTrigger,
  DropdownContent
} from 'react-simple-dropdown'
import { Link } from 'react-router'
import styled from 'styled-components'
import colors from '../../styles/colors'

const DropdownItem = styled(Link)`
  color: inherit;

  &:hover,
  &:focus {
    box-shadow: inset 3px 0 ${colors.primary};
  }
`

const MockLink = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 1rem;
  transition: box-shadow 0.2s;
  color: rgb(120, 130, 140);
  margin-right: 0.5rem;

  &:hover {
    box-shadow: inset 0 -3px ${colors.primary};
  }

  &:hover,
  &:focus {
    color: rgb(100, 110, 120);
    text-decoration: none;
  }
`

class SellDropdown extends Component {
  dropdown: any

  render() {
    return (
      <Dropdown
        ref={(node) => {
          this.dropdown = node
        }}
        style={{ height: '100%' }}
      >
        <DropdownTrigger
          style={{ height: '100%', display: 'flex', textDecoration: 'none' }}
        >
          <MockLink>Sell</MockLink>
        </DropdownTrigger>
        <DropdownContent>
          <DropdownItem
            to="/sell"
            className="dropdown-item"
            onClick={() => this.dropdown.hide()}
          >
            Home Valuation
          </DropdownItem>
          <DropdownItem
            to="/hire-us"
            className="dropdown-item"
            onClick={() => this.dropdown.hide()}
          >
            Hire Us
          </DropdownItem>
        </DropdownContent>
      </Dropdown>
    )
  }
}

export default SellDropdown



// WEBPACK FOOTER //
// ./src/components/SellDropdown/index.js